import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#ffffff",
        secondary: "#323232",
        accent: "#1E2B36",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#2E5EC0",
        footer: "#303b44",
        features: "#4D5863",
        thumb: "#c6c4c4",
        thumbOn: "#2E5EC0",
        otherModules: "#FFFFFF",
        pwaButton: "#ffffff",
        drawer: "#67727b",
        drawerModulesText: "#858686",
        menuColor: "#E1E1E1",
        searchColor: "#EBEDEF",
        drawerModulesIconColor: "#606060",
        levelTitle: "#8BCDD8",
        currentLevel: "3A8897",
        otherLevelTitles: "#899198",
        benefitCard: "#2F3A44",
        otherModulesCard: "#F81717",
        carouselHome: "#899198"
      },
      dark: {
        primary: "#272727",
        secondary: "#000000",
        accent: "#FFFFFF",
        footer: "#272727",
        features: "#232323",
        thumb: "#40474c",
        thumbOn: "#2E5EC0",
        warning: "#2E5EC0",
        otherModules: "#383838",
        pwaButton: "#1d1d1d",
        drawer: "#67727b",
        drawerModulesText: "#FFFFFF",
        searchColor: "#272727",
        menuColor: "#383838",
        drawerModulesIconColor: "#FFFFFF",
        benefitCard: "#4A4A4A",
        otherLevelTitles: "#899198",
        levelTitle: "#8BCDD8",
        currentLevel: "3A8897",
        otherModulesCard: "#F81717",
        carouselHome: "#383838"
      }
    }
  }
});
